module.exports = __webpack_public_path__ + "img/18.4c15ae5c.jpg";